import dJSON from 'dirty-json';

/**
 * Check if the page has the class request-an-account
 */
(() => {
  if (document.querySelector('.request-an-account-form')) {
    // Add the class to the body tag
    document.body.classList.add('request-an-account-page');

    // Add a class to the main row
    const mainRow = document.querySelector('.catalog-grid .container > .row');
    mainRow.classList.add('main-row');
  }
})();

/**
 * Custom Upload Area Button
 */
(() => {
  const area = document.querySelector('.custom-upload-area button');
  if (!area) {
    return;
  }

  const input = document.querySelector('input.uploadbutton');

  area.onclick = () => {
    if (input) {
      input.click();
    }
  };

  input.onchange = () => {
    const fileNameContainer = area.querySelector('.file');
    let value;
    if (input.value) {
      // Split the input value by both forward slash and backslash
      const parts = input.value.split(/[/\\]/);
      value = parts[parts.length - 1];
    }

    fileNameContainer.innerText = value;

    // Add class to change color when file value is present
    if (value) {
      fileNameContainer.classList.add('has-file');
    } else {
      fileNameContainer.classList.remove('has-file');
    }
  };
})();

/**
 * Select placeholder
 */
(() => {
  const selectElements = document.querySelectorAll('select');

  selectElements.forEach((selectElement) => {
    selectElement.addEventListener('change', function () {
      if (this.value === '') {
        this.classList.add('placeholder');
      } else {
        this.classList.remove('placeholder');
      }
    });

    // Initial check
    if (selectElement.value === '') {
      selectElement.classList.add('placeholder');
    }
  });
})();

/**
 * Our Services Widget
 */
(() => {
  const moduleSelector = '.our-services'; // Name of the div where it is
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      console.log(data);

      data.forEach((item) => {
        query.querySelector('.content-wrapper').insertAdjacentHTML('beforeend', /* html */ `
          <div class="service">
            <div class="icon">
              <img src="${item.icon}" alt="Icon"/>
            </div>
            <div class="content">
              <p class="service-name">${item.service}</p>
              <div class="description">${item.description}</div>
            </div>
            <div class="image-wrapper">
              <img src="${item.image}" alt="Image"/>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Hide the upload area when taxable is checked
 */
(() => {
  const taxesOptions = document.querySelector('.options.taxes');
  const uploadArea = document.querySelector('.row.upload-file');

  if (taxesOptions && uploadArea) {
    const optionTaxable = taxesOptions.querySelector('input[value="taxable"]');
    taxesOptions.addEventListener('change', () => {
      if (optionTaxable.checked) {
        uploadArea.classList.add('hide');
      } else {
        uploadArea.classList.remove('hide');
      }
    });
  }
})();
